import DialogActions, {
  type DialogActionsProps
} from '@mui/material/DialogActions';
import { type PropsWithChildren, forwardRef } from 'react';

const CustomFooter = forwardRef<
  HTMLDivElement,
  PropsWithChildren<DialogActionsProps>
>(({ children, ...props }, ref) => {
  return (
    <DialogActions
      ref={ref}
      sx={{ padding: '12px', height: '52px' }}
      {...props}
    >
      {children}
    </DialogActions>
  );
});

CustomFooter.displayName = 'CustomFooter';

export default CustomFooter;
